import styled from "styled-components";

const ListItem = styled.li`
  color: ${props => props.theme.offWhite};
  font-size: 1.6rem;
  font-weight: 300;
`;

export default ListItem;
